import React, { useState } from 'react'
import Header from './components/Header'
import CoverLetterForm from './components/CoverLetterForm'
import Preview from './components/Preview'
import DownloadButton from './components/DownloadButton'
import GlobalStyles from './styledComponents/GlobalStyles'

function App() {
  const [formData, setFormData] = useState({
    name: '',
    role: '',
    skills: '',
  })

  return (
    <>
      <GlobalStyles />
      <Header />
      <CoverLetterForm formData={formData} setFormData={setFormData} />

      {/* Wrap only the letter in this ID */}
      <div id="letter-content">
        <Preview formData={formData} />
      </div>

      {/* This button should be OUTSIDE the letter-content */}
      <DownloadButton />
    </>
  )
}

export default App
